// libraries
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Button, Popover, Grid } from '@mui/material'

const ScalePopover = ({ scalePopoverData, setScalePopoverData, callReadScale, onScaleSelected }) => {
  const { devices, selectedScaleIds } = useSelector(state => state.devices)
  const activeScales = useMemo(
    () => devices?.filter(device => (selectedScaleIds || []).indexOf(device.id) > -1),
    [devices, selectedScaleIds],
  )

  return (
    <Popover
      open={!!scalePopoverData.anchorEl}
      anchorEl={scalePopoverData.anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={() => setScalePopoverData({})}
    >
      <Grid container spacing={1} padding={2} borderRadius={1} width={400}>
        {activeScales.map(scale => (
          <Grid item xs={6} key={scale?.id}>
            <Button
              variant="outlined"
              sx={{
                border: 1,
                borderColor: 'grey.400',
                borderRadius: 2,
                height: 100,
                width: '100%',
              }}
              onClick={() => {
                const scaleId = scale.id
                onScaleSelected(scaleId)
                callReadScale({ ...scalePopoverData, scaleId })
                setScalePopoverData({})
              }}
            >
              {scale.name}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Popover>
  )
}

ScalePopover.propTypes = {
  scalePopoverData: PropTypes.object.isRequired,
  setScalePopoverData: PropTypes.func.isRequired,
  callReadScale: PropTypes.func.isRequired,
  onScaleSelected: PropTypes.func,
}

ScalePopover.defaultProps = {
  onScaleSelected: () => {},
}

export default ScalePopover
